import { ReactNode } from "react";

import styles from "../../styles/Label.module.less";

type LabelProps = {
  children: ReactNode;
  htmlFor?: string;
};

const Label = ({ children, htmlFor }: LabelProps) => {
  return (
    <label htmlFor={htmlFor} className={styles.label}>
      {children}
    </label>
  );
};
export default Label;
